import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

/** This is a single-page app, so GA4 never sees a second document load — each route change is
 *  reported here instead. Renders nothing and touches no state. */
export const AnalyticsRoutes = () => {
  const { pathname } = useLocation();
  const sent = useRef(null);

  useEffect(() => {
    // One view per path, however many times the effect runs.
    if (sent.current === pathname) return;
    sent.current = pathname;
    trackPageView(pathname, document.title);
  }, [pathname]);

  return null;
};
